// extracted by mini-css-extract-plugin
export default {"card":"CreateGroup_card__gckSv","container":"CreateGroup_container__bOxVu","content":"CreateGroup_content__utLH1","btn":"CreateGroup_btn__mpea6"};